module.exports = __webpack_public_path__ + "img/mesa_p001.af54c85f.png";